const ENDPOINT = 'landing-pages';

export const landingPagesApiFactory = ({ callPostApi, callGetApi, callDeleteApi }) => ({
    createLandingPage: ({ accountId, accountName, ...lpPayload }) => {
        return callPostApi(`/${accountName}/${ENDPOINT}`, {
            ...lpPayload,
        });
    },
    getLandingPage: ({ accountName, landingPageId }) => {
        return callGetApi(`/${accountName}/${ENDPOINT}/${landingPageId}`);
    },
    getAllLandingPages: ({ accountName }) => {
        return callGetApi(`/${accountName}/${ENDPOINT}`);
    },
    editLandingPage: ({ accountName, landingPageId, ...lpPayload }) => {
        return callPostApi(`/${accountName}/${ENDPOINT}/${landingPageId}`, {
            ...lpPayload,
        });
    },
    chatEditLandingPage: ({ accountName, landingPageId, prompt }) => {
        return callPostApi(`/${accountName}/${ENDPOINT}/${landingPageId}/chat`, {
            prompt,
        });
    },
    duplicateLandingPage: ({ accountName, landingPageId, ...lpPayload }) => {
        return callPostApi(`/${accountName}/${ENDPOINT}/${landingPageId}/duplicate`, {
            ...lpPayload,
        });
    },
    deleteLandingPage: ({ accountName, landingPageId }) => {
        return callDeleteApi(`/${accountName}/${ENDPOINT}/${landingPageId}`);
    },
});
